import { createSelector, Selector } from '@reduxjs/toolkit';
import type { tSharedAppState, tSharedStore } from '../../types';
import parentSelectors from '../selectors';
import { tTestsTab, IFreeCoursesState } from './types';

type tTestsState = tSharedStore['member']['testsPage'];
type tTabState = tTestsState[tTestsTab];

const selectStore: Selector<tSharedAppState, tTestsState> = createSelector(
  [parentSelectors.selectMemberStore],
  (parent) => parent.testsPage
);

const selectTab = (tab: tTestsTab): Selector<tSharedAppState, tTabState> =>
  createSelector([selectStore], (store) => store[tab]);

const selectFreeCourses: Selector<tSharedAppState, IFreeCoursesState> = createSelector(
  [selectStore],
  (store) => store.freeCourses
);

const selectors = {
  selectStore,
  selectTab,
  selectFreeCourses
};

export { selectors };
